var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1379 14.3176H24.9725V9.82262C24.9725 4.45378 21.102 0.25 15.5664 0.25C10.0309 0.25 6.24351 4.53687 6.24351 9.82262V14.2761H5.07815C2.49777 14.2761 0.416769 16.3571 0.375 18.9793V33.0469C0.375 35.6272 2.45601 37.7082 5.07815 37.75H26.1379C28.7183 37.75 30.7993 35.669 30.8411 33.0469V18.9785C30.8411 16.3981 28.7183 14.3171 26.1379 14.3171V14.3176ZM8.57423 14.3176V9.82262C8.57423 5.82694 11.3212 2.58065 15.5663 2.58065C19.7698 2.58065 22.6416 5.7437 22.6416 9.82262V14.2761L8.57401 14.2758V14.3176L8.57423 14.3176ZM28.4686 33.0466C28.4686 34.3368 27.4281 35.3773 26.138 35.3773H5.07822C3.78807 35.3773 2.74757 34.3368 2.74757 33.0466V18.979C2.74757 17.6889 3.78807 16.6484 5.07822 16.6484H26.138C27.4281 16.6484 28.4686 17.6889 28.4686 18.979V33.0466ZM17.9388 23.6821C17.9388 24.5563 17.4809 25.3053 16.7734 25.7216H16.7319H16.7734V29.5506C16.7734 30.2166 16.2322 30.716 15.608 30.716C14.942 30.716 14.4427 30.1748 14.4427 29.5506V25.7216H14.4842H14.4427C13.7352 25.3053 13.2773 24.5562 13.2773 23.6821C13.2773 22.392 14.3178 21.3515 15.608 21.3515C16.8981 21.3097 17.9386 22.3502 17.9386 23.6821H17.9388Z",
    fill: "#8D027D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d8e86ea3b67ec7061fed5191462a55bd.svg";
export { ForwardRef as ReactComponent };